import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumSpiritDutyExemptionReason implements BaseEnumType {
  private static allValues: EnumSpiritDutyExemptionReason[] = []; // make sure this is top-most
  
  public static none = new EnumSpiritDutyExemptionReason(0, "None", "enum_spirit_duty_exemption_reason_none");
  public static forFortifyingWine = new EnumSpiritDutyExemptionReason(1, "ForFortifyingWine", "enum_spirit_duty_exemption_reason_for_fortifying_wine");
  public static soldForExemptUse = new EnumSpiritDutyExemptionReason(2, "SoldForExemptUse", "enum_spirit_duty_exemption_reason_sold_for_exempt_use");
  public static forExemptUse = new EnumSpiritDutyExemptionReason(3, "ForExemptUse", "enum_spirit_duty_exemption_reason_for_exempt_use");
  public static denatured = new EnumSpiritDutyExemptionReason(4, "Denatured", "enum_spirit_duty_exemption_reason_denatured");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumSpiritDutyExemptionReason.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumSpiritDutyExemptionReason.none; }
  public isForFortifyingWine() { return this === EnumSpiritDutyExemptionReason.forFortifyingWine; }
  public isSoldForExemptUse() { return this === EnumSpiritDutyExemptionReason.soldForExemptUse; }
  public isForExemptUse() { return this === EnumSpiritDutyExemptionReason.forExemptUse; }
  public isDenatured() { return this === EnumSpiritDutyExemptionReason.denatured; }

  public static getValues(): readonly EnumSpiritDutyExemptionReason[] {
    return EnumSpiritDutyExemptionReason.allValues;
  }

  public static getValuesExcept0(): readonly EnumSpiritDutyExemptionReason[] {
    return EnumSpiritDutyExemptionReason.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumSpiritDutyExemptionReason {
    const found = EnumSpiritDutyExemptionReason.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumSpiritDutyExemptionReason - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumSpiritDutyExemptionReason): EnumSpiritDutyExemptionReason {
    const found = name ? EnumSpiritDutyExemptionReason.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumSpiritDutyExemptionReason - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumSpiritDutyExemptionReason>): boolean {
    return this.key === other?.key;
  }
}